// extracted by mini-css-extract-plugin
module.exports = {"heading":"headings_heading__ueTl9"};